import React from 'react';
import {
  SaveButton,
  required,
  TextInput,
  usePermissions,
  SelectInput,
  Labeled,
  TextField,
} from 'react-admin';

import { useFormContext } from 'react-hook-form';

import {
  Box,
  Grid,
} from '@mui/material';

import useRequestTypesChoices from '../../hooks/useRequestTypesChoices';

import hasAccess from '../../utilities/hasAccess';

import EditDialog from '../layout/dialog/EditDialog';

import ActivationButton from '../../customFields/ActivationButton';

import actions, { Actions } from '../../constants/actions';
import resourceTypes from '../../constants/resourceTypes';

const CustomToolbar = () => {
  const { formState: { isValid } } = useFormContext();
  const { permissions } = usePermissions<Actions[]>();

  return (
    <Box display="flex" justifyContent="space-between" gap={2} marginTop={4}>
      {hasAccess(permissions, actions.PROCESS_UPDATE_ACTIVATION) && (
        <ActivationButton />
      )}
      {hasAccess(permissions, actions.PROCESS_UPDATE) && (
        <SaveButton
          disabled={!isValid}
          icon={null}
        />
      )}
    </Box>
  );
};

const ProcessEdit = () => {
  const { choices } = useRequestTypesChoices();

  return (
    <EditDialog
      customToolbar={<CustomToolbar />}
      title="process"
      action={actions.PROCESS_GET}
      resourceType={resourceTypes.PROCESS}
    >
      <Grid container spacing={6}>
        <Grid size={12}>
          <Labeled label="ID">
            <TextField source="id" />
          </Labeled>
        </Grid>
        <Grid size={12}>
          <Labeled label="Name">
            <TextInput fullWidth validate={required()} source="name" label="" helperText={false} />
          </Labeled>
        </Grid>
        <Grid size={12}>
          <Labeled label="Request type">
            <SelectInput
              source="requestType"
              label=""
              choices={choices}
              validate={required()}
              helperText={false}
            />
          </Labeled>
        </Grid>
      </Grid>
    </EditDialog>
  );
};

export default ProcessEdit;
